<template>
  <div class="wrapper">
    <header class="navbar">
      <!-- Navbar Desktop -->
      <ul class="navbar-nav" v-if="breakpointFunction">
        <li class="nav-item" v-for="item in nav" :key="item.id">
          <a class="nav-link" v-if="item.show" @click="setActive(item)" :class="{ active: item.active }">{{
            item.text
          }}</a>
        </li>
      </ul>

      <v-app-bar-nav-icon
        v-if="!breakpointFunction"
        @click="dialog = true"
        class="textAccentColor--text"
      ></v-app-bar-nav-icon>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" class="white--text">
        <v-card>
          <v-toolbar text color="white">
            <v-toolbar-title class="textAccentColor--text">Praktijk May-Britt</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="dialog = false" color="textAccentColor">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-list nav dense>
            <v-list-item-group v-model="selectedItem" color="textAccentColor">
              <v-list-item v-for="(item, i) in nav" :key="i" @click="goToItem(item)">
                <v-list-item-content>
                  <v-list-item-title v-if="item.show" v-text="item.text"></v-list-item-title>
                  <!-- <a class="nav-link" @click="setActive(item)" :class="{ active: item.active }" :href="item.to">{{
                    item.text
                  }}</a> -->
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-dialog>
    </header>
    <v-main class="main">
      <!-- AFBEELDING BOVEN IN  -->
      <div class="jumbotron">
        <div class="mw-wrapper d-flex flex-column p-5">
          <h1>Praktijk May-Britt</h1>
          <p class="pt-5 p-3-rem text-center subtitle-text">
            <span>
              Zit je niet lekker in je vel? Heb je last van (chronische) lichamelijke klachten? <br />
              Dan is het belangrijk te zoeken naar de oorzaak van je klachten en niet alleen de symptomen te bestrijden.
              De oorzaak komt namelijk van binnenuit. <br />
            </span>
            Ik help je graag om tot een oplossing te komen! <br />
          </p>
          <v-btn outlined class="outlined-button" @click="goToItem({ to: '#footer' })"> Maak een afspraak</v-btn>
        </div>
      </div>
    </v-main>
    <!--  WAT IS VOETREFLEX? -->
    <section class="position-r">
      <v-row no-gutters class="position-r" id="wat-is-voetreflex" ref="wat-is-voetreflex">
        <div class="mw-wrapper z-index-2">
          <div class="align-content-start p-3-rem mw-wrapper flex-column">
            <h1>Wat is orthomoleculaire therapie?</h1>
            <p class="pt-4 pb-4">
              Orthomoleculaire therapie is een onderdeel van de natuurgeneeskunde, gebaseerd op wetenschappelijk
              onderzoek. Vrouwen die zwanger willen worden krijgen het advies om foliumzuur te slikken, pasgeboren
              baby’s extra vitamine K, veganisten vitamine B12, ouderen vitamine D. Dat zijn algemeen geaccepteerde
              vormen van orthomoleculaire geneeskunde. <br />
              <br />

              Orthomoleculaire therapie is erop gericht de gezondheid te bevorderen of ziekteprocessen te herstellen. De
              behandeling heeft tot doel om de lichaamscellen (onze bouwstenen) te voorzien van optimale hoeveelheden
              vitamines, mineralen en andere noodzakelijke voedingsstoffen. Uit een groeiend aantal wetenschappelijke
              onderzoeken blijkt dat er relatie bestaat tussen voeding en ziekten. Zo is inmiddels duidelijk dat slechte
              voedingsgewoonten een rol spelen bij het ontstaan van bijvoorbeeld kanker, hart- en vaatziekten en
              diabetes.
            </p>
          </div>
        </div>
      </v-row>
    </section>

    <!-- 2 BLOKKEN MET INFO -->
    <section class="position-r bg-color">
      <v-row no-gutters class="p-3-rem" id="wat-is-voetreflex">
        <div class="mw-wrapper justify-center">
          <v-row class="justify-center gap-1">
            <v-col cols="12" md="5" sm="12" xs="12" lg="5" xl="5" class="border-accent">
              <h2>Wat is voetreflextherapie?</h2>
              <p class="pt-3">
                Op de voeten bevinden zich reflexpunten die corresponderen met alle organen, klieren, spieren, botten en
                zenuwen in ons lichaam. Door reflextherapie op deze punten worden de organen en bloedsomloop
                gestimuleerd, afvalstoffen afgevoerd en je zelf genezend vermogen wordt in werking gezet. Door
                specifieke drukpunten op de voeten te stimuleren, gaat het lichaam signalen afgeven, waardoor er
                positieve stoffen zoals endorfine vrijkomen. Hierdoor zul je uiteindelijk minder stress en pijn ervaren.
                Daarnaast helpt voetreflextherapie bij het verminderen van gifstoffen, spanningen en ontstekingen.
              </p>
            </v-col>
            <v-col cols="12" md="5" sm="12" xs="12" lg="5" xl="5" class="border-accent">
              <h2>Verbeter uw gezondheid</h2>
              <p class="pt-3">
                Gezond worden en blijven heeft te maken met het vinden en behouden van de juiste lichamelijke en
                geestelijke balans. Als de balans wordt verstoord kunnen er allerlei klachten over je gezondheid
                ontstaan. Orthomoleculaire therapie is gebaseerd op het behandelen van de oorzaken van
                gezondheidsklachten en niet op de symptomen. Niet alleen maar voeding is belangrijk. Beweging, slaap,
                ontspanning, je gedachten en mindset horen ook bij het voeding van je lichaam. Alles heeft invloed op je
                gezondheid. Passend individueel advies is hierbij de sleutel naar succes omdat niemand hetzelfde is,
                zelfs met een gelijke diagnose!
              </p>
            </v-col>
          </v-row>
        </div>
      </v-row>
    </section>

    <!-- WAT KAN HET BETEKENEN VOOR U? -->
    <div class="">
      <div class="mw-wrapper p-3-rem">
        <v-row>
          <v-col cols="12" class="pb-0">
            <h1>Wat kan een orthomoleculair therapeut voor jou betekenen?</h1>
            <p class="pt-4">
              Een orthomoleculair therapeut kan niet alleen ondersteuning bieden als je lichamelijke klachten ondervindt
              door een chronische aandoening, maar draagt tevens bij aan het verbeteren van algehele lichamelijke
              gezondheid door de balans in het lichaam te herstellen. Voor welke klachten kan orthomoleculaire- en
              voetreflextherapie toegepast worden: In principe kan dit voor bijna alle (chronische) klachten en
              ziektebeelden toegepast worden, hieronder een aantal voorbeelden:
            </p>
          </v-col>
          <v-col cols="6">
            <ul>
              <li>Vermoeidheid</li>
              <li>Darmklachten (buikpijn, opgeblazen gevoel, wisselend ontlastingspatroon)</li>
              <li>Hormonale disbalans</li>
              <li>Overgewicht</li>
              <li>Migraine</li>
              <li>Hernia- rug- nek en schouderklachten</li>
              <li>Gewrichtsklachten</li>
              <li>Tennis-golfersarm en hielspoor</li>
            </ul>
          </v-col>
          <v-col cols="6">
            <ul>
              <li>Zwangerschapswens</li>
              <li>Herstel na zwangerschap</li>
              <li>Spierkramp</li>
              <li>Stress/ spanning</li>
              <li>Rouwverwerking</li>
              <li>Slaapproblemen</li>
              <li>Hoge bloeddruk</li>
            </ul>
          </v-col>

          <p>
            Een voetreflexbehandeling of massage is voor iedereen toegankelijk, van jong tot oud. Herken je jezelf in
            één of meerdere van bovenstaande symptomen, dan is een voetreflexbehandeling en/ of orthomoleculaire
            therapie een goede mogelijkheid om verlichting te brengen.
          </p>
        </v-row>
      </div>
    </div>

    <!-- WAT KUNT U VERWACHTEN? -->
    <section class="position-r pink-bg">
      <v-row class="mw-wrapper p-3-rem" id="wat-kunt-u-verwachten" ref="wat-kunt-u-verwachten">
        <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
          <h1>Wat kun je verwachten?</h1>
          <ul class="pt-3">
            <li>Ontspanning en meer energie</li>
            <li>Het herstellen van innerlijke- en fysieke balans</li>
            <li>Verbetering van de doorbloeding</li>
            <li>Het verminderen van stess/ onrust</li>
          </ul>

          <p class="pt-8">
            Wil jij eerst even kennismaken of wil je meer informatie? Boek dan nu je vrijblijvende telefonische
            kennismaking of stuur mij een e-mail.
          </p>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
          <div>
            <v-carousel>
              <v-carousel-item
                src="../../../public/voeten.jpg"
                reverse-transition="fade-transition"
                transition="fade-transition"
              ></v-carousel-item>
              <v-carousel-item
                src="../../../public/example-1.jpg"
                reverse-transition="fade-transition"
                transition="fade-transition"
              ></v-carousel-item>
            </v-carousel>
          </div>
        </v-col>
      </v-row>
    </section>

    <!-- OVER MIJ -->
    <section class="position-r">
      <v-row class="row mw-wrapper pt-5" id="over-mij" ref="over-mij">
        <v-col cols="5" xs="12" class="image z-index-2">
          <div class="home-about-image-wrapper">
            <img src="../../../public/may-britt-3.jpg" alt="" />
          </div>
        </v-col>
        <v-col cols="12" md="7" sm="12" xs="12" lg="7" xl="7"
          ><div class="align-content-start ps-3 about-content">
            <h1>Over mij</h1>
            <p class="pt-3">
              Mijn naam is May-Britt Koeleman. Ik woon samen met mijn man en zoon in Alphen aan den Rijn. Ik ben ruim 10
              jaar werkzaam als doktersassistente en spreekuurondersteuner (SOH) en heb ervaring in zowel het ziekenhuis
              als de huisartsenzorg. Daarnaast ben ik afgestudeerd als orthomoleculair therapeut en voetreflextherapeut.
              Dit vind ik beide een mooie aanvulling op de reguliere geneeskunde.

              <br /><br />Steeds meer mensen hebben last van ''vage'', soms chronische klachten. Via de reguliere
              geneeskunde, huisartsen en medisch specialisten wordt er veel aan symptoombestrijding gedaan en tot op
              heden weinig naar de onderliggende oorzaak. Waar komen de klachten vandaan? Onze westerse levensstijl
              leidt er vaak toe dat ons lichaam uit balans raakt. De fysieke klachten zijn een signaal van een
              disbalans, een alarmbel die afgaat.

              <br /><br />
              Ik wil mij vooral richten op het vroegtijdig signaleren van gezondheidsproblemen (preventie), het
              terugdringen van stress en het verbeteren van (chronische) klachten. Ik denk praktisch mee hoe de adviezen
              passen in jouw leven. Ik weet zelf ook hoe lastig het is om gezondheid en een druk leven samen te
              combineren. Daarom wil ik jou graag helpen om deze combi te kunnen maken. Het belangrijkste vind ik dat
              mensen gezonder en gelukkiger kunnen leven; dat is mijn doel.
            </p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!-- MIJN TARIEVEN -->
    <v-row class="p-3-rem bg-color" id="tarieven" ref="tarieven">
      <v-row class="mw-wrapper flex-column align-start">
        <h1 class="">Tarieven</h1>

        <v-simple-table class="w-100 mt-5">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Behandeling
                </th>
                <th class="text-left">
                  Tarief
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="">
                <td>Gratis kennismaking telefonisch of fysiek</td>
                <td>-</td>
              </tr>
              <tr class="">
                <td>1 op 1 traject gedurende 6 maanden</td>
                <td>€650,- (betalen in 2 of 3 termijnen is mogelijk)</td>
              </tr>
              <tr class="">
                <td>Orthomoleculair advies</td>
                <td>€85,- per consult</td>
              </tr>
              <tr class="">
                <td>Voetreflexbehandeling</td>
                <td>€60,- per behandeling (60 minuten)</td>
              </tr>
              <tr class="">
                <td>Voetreflexbehandeling aan huis</td>
                <td>€75,-</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-row>

    <!-- EXTRA -->
    <v-row class="mw-wrapper flex-column p-3-rem align-center text-center">
      <h1>Kan ik u helpen?</h1>
      <p class="pt-3">Maak een afspraak <br />Bel of email mij op de onderstaande gegevens</p>

      <v-icon @click="goToItem({ to: '#footer' })" class="pointer-hover">mdi-arrow-down-circle-outline</v-icon>
    </v-row>

    <!-- FOOTER -->
    <footer class="pt-5 grey-color" id="footer" ref="footer">
      <v-row class="mw-wrapper footer-content pb-5 align-start">
        <v-col cols="12" md="4" sm="4" xs="12" lg="4" xl="4">
          <div class="d-flex flex-column pr-5 footer-item">
            <h3>Contactgegevens</h3>
            <div>May-Britt Kok-Koeleman</div>
            <div>praktijkmay-britt@hotmail.com</div>
            <div>06-34700840</div>
          </div>
        </v-col>
        <v-col cols="12" md="4" sm="4" xs="12" lg="4" xl="4">
          <div class="d-flex flex-column pr-5 footer-item">
            <h3>Adres</h3>
            <div>Ambonstraat 84</div>
            <div>2405 ER</div>
            <div>Alphen aan den Rijn</div>
          </div>
        </v-col>

        <v-col cols="12" md="4" sm="4" xs="12" lg="4" xl="4">
          <div class="d-flex flex-column pr-5 footer-item">
            <h3>Social media</h3>
            <!-- <a href="https://www.instagram.com/praktijk.maybritt/" class="d-flex align-items-center">
              <v-icon class="pr-2">mdi-facebook</v-icon> Facebook</a
            > -->
            <a href="https://www.instagram.com/praktijk.maybritt/" target="_blank" class="d-flex align-items-center"
              ><v-icon class="pr-2">mdi-instagram</v-icon>Instagram</a
            >
          </div>
        </v-col>
      </v-row>
      <v-row class="bg-color py-3 pl-5">
        <div class=" mw-wrapper w-100">
          © Copyright 2023
        </div>
      </v-row>
    </footer>
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({
    mobile: false,
    dialog: false,
    nav: [
      {
        id: 2,
        text: 'Wat is orthomoleculaire therapie?',
        title: 'Wat is orthomoleculaire therapie?',
        to: '#wat-is-voetreflex',
        active: true,
        show: true
      },
      {
        id: 3,
        text: 'Wat kunt u verwachten?',
        title: 'Wat kunt u verwachten?',
        to: '#wat-kunt-u-verwachten',
        active: false,
        show: true
      },
      {
        id: 1,
        text: 'Over mij',
        to: '#over-mij',
        active: false,
        show: true
      },
      {
        id: 4,
        text: 'Tarieven',
        title: 'Tarieven',
        to: '#tarieven',
        active: false,
        show: true
      },
      {
        id: 6,
        text: 'Contact',
        title: 'Contact',
        to: '#footer',
        active: false,
        show: true
      },
      {
        id: 5,
        text: 'Footer',
        title: 'Footer',
        to: '#footer',
        active: false,
        show: false
      }
    ],
    selectedItem: 0
  }),
  computed: {
    breakpointFunction() {
      if (this.$vuetify.breakpoint.width < 650) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {},
  async mounted() {},
  methods: {
    setActive(item) {
      this.nav.forEach(element => {
        element.active = false
      })
      let activeNav = this.nav.find(x => x.id == item.id)
      if (activeNav) activeNav.active = true
      this.goToItem(item)
    },
    goToItem(obj) {
      const id = obj.to.replace('#', '')
      this.$refs[`${id}`].scrollIntoView({ behavior: 'smooth' })
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';
.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
  border-bottom: 1px solid $secondary;
}
.v-sheet.v-list:not(.v-sheet--outlined) {
  border-top: 2px solid $secondary;
}
.v-toolbar__title {
  font-family: 'Dancing Script';
  color: $text-accent-color;
  font-size: 1.5rem;
}
</style>
